import { BatchId } from '@/Domain/Batch'
import { ShamirHash } from './ShamirHash'

const MD5_REGEX = /^[a-f0-9]{32}$/

export class EncryptedXmlOffer {
  private _batchId: BatchId
  private _md5Hash: string
  private _shamirHashes: ShamirHash[]

  constructor (batchId: string, recordId: string, md5Hash: string, shamirHashes: ShamirHash[]) {
    this._batchId = new BatchId(batchId, recordId)
    if (MD5_REGEX.test(md5Hash) === false) {
      throw new TypeError('MD5 hash provided not valid')
    }
    this._md5Hash = md5Hash
    this._shamirHashes = shamirHashes
  }

  batchId (): string {
    return this._batchId.batchId()
  }

  recordId (): string {
    return this._batchId.recordId()
  }

  md5Hash (): string {
    return this._md5Hash
  }

  shamirHashes (): ShamirHash[] {
    return this._shamirHashes
  }
}
